import { render, staticRenderFns } from "./PushRecords.vue?vue&type=template&id=4af70ab5&scoped=true&"
import script from "./PushRecords.vue?vue&type=script&lang=js&"
export * from "./PushRecords.vue?vue&type=script&lang=js&"
import style0 from "./PushRecords.vue?vue&type=style&index=0&id=4af70ab5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af70ab5",
  null
  
)

export default component.exports